"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionRewardsDisplay = ShopPageSubscriptionRewardsDisplay;
exports.ShopPageSubscriptionAccrualPercentage = ShopPageSubscriptionAccrualPercentage;
exports.ShopPageSubscriptionAvailablePoint = ShopPageSubscriptionAvailablePoint;
const react_i18next_1 = require("react-i18next");
const react_1 = __importDefault(require("react"));
function ShopPageSubscriptionRewardsDisplay({ accrualPercentage, availablePoint }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "loyalties__orders-box-header" },
            react_1.default.createElement("span", { "data-fieldname": "shop_subscription_order_header", className: "loyalties__orders-box-title" }, t("text.mmsubscription.settings.header.subscription.rewards"))),
        react_1.default.createElement("div", { id: "rewards-content" },
            react_1.default.createElement(ShopPageSubscriptionAccrualPercentage, { accrualPercentage: accrualPercentage }),
            react_1.default.createElement(ShopPageSubscriptionAvailablePoint, { availablePoint: availablePoint })));
}
function ShopPageSubscriptionAccrualPercentage({ accrualPercentage }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return react_1.default.createElement("div", { className: "highlight-well-wrapper" },
        react_1.default.createElement("div", { className: "highlight-well primary" },
            react_1.default.createElement("i", { className: "icon--calendar-alt-white icon--lg icon--no-hover" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "highlight-heading" },
                    accrualPercentage,
                    " ",
                    t("text.back")),
                react_1.default.createElement("div", { className: "highlight-content" }, t("text.mmsubscription.rewards.percentage.caption.heading")))));
}
function ShopPageSubscriptionAvailablePoint({ availablePoint }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return react_1.default.createElement("div", { className: "highlight-well-wrapper" },
        react_1.default.createElement("div", { className: "highlight-well secondary" },
            react_1.default.createElement("i", { className: "icon--rewards-white icon--lg icon--no-hover" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "highlight-heading" }, availablePoint),
                react_1.default.createElement("div", { className: "highlight-content" }, t("text.mmsubscription.rewards.reward.points")))));
}
